// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"B2_thecomp__OObzw"};